import { render, staticRenderFns } from "./trendForm.vue?vue&type=template&id=6d4e739f&scoped=true"
import script from "./trendForm.vue?vue&type=script&lang=js"
export * from "./trendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e739f",
  null
  
)

export default component.exports